import { EVENTS as BaseEvents } from '@/app/shared/utils/constants';
import { apiConstants } from './api-constants';
let code = apiConstants.code;

export const EVENTS = {
    SELECT_FEATURE: BaseEvents.SELECT_FEATURE,
    UNSELECT_FEATURE: BaseEvents.UNSELECT_FEATURE,
    UPDATE_FEATURE: BaseEvents.UPDATE_FEATURE,
    INITIALIZE_NEW_FEATURE: BaseEvents.INITIALIZE_NEW_FEATURE,
    FINISHED_NEW_FEATURE: BaseEvents.FINISHED_NEW_FEATURE,
    SHOW_MODAL_NEW_FEATURE: `${code}:new-feature-show-modal`,
    SHOW_MODAL_DETAIL_FEATURE: `${code}:detail-feature-show-modal`,
    CLOSE_MODAL_DETAIL_FEATURE: `${code}:detail-feature-close-modal`,
    SHOW_MODAL_EDIT_FEATURE: `${code}:edit-feature-show-modal`,
    CLOSE_MODAL_EDIT_FEATURE: `${code}:edit-feature-close-modal`,
    SHOW_MODAL_NOTIFY_FEATURE: `${code}:notify-feature-show-modal`,
    CLOSE_MODAL_NOTIFY_FEATURE: `${code}:notify-feature-close-modal`,
};